import { render, staticRenderFns } from "./CookiebotDeclaration.vue?vue&type=template&id=1a411d72&"
import script from "./CookiebotDeclaration.vue?vue&type=script&lang=ts&"
export * from "./CookiebotDeclaration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a411d72')) {
      api.createRecord('1a411d72', component.options)
    } else {
      api.reload('1a411d72', component.options)
    }
    module.hot.accept("./CookiebotDeclaration.vue?vue&type=template&id=1a411d72&", function () {
      api.rerender('1a411d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CookiebotDeclaration.vue"
export default component.exports